import {
  GET_ACCURACY_WEIGHTAGE_URL,
  GET_APP_BANNER_DATA_URL,
  GET_CT_DISABLED_EVENT_LIST_URL,
} from "../../api/common/constant";
import { NUDGE_CITY_LIST } from "../../api/locationLock/constant";
import { CURRENCY_LIST, LOTTIE_ICONS } from "../../constants/common/common";
import { SALE_NUDGE } from "../../constants/pageConstants/pdpConstants";
import { santaTrendingProducts } from "../../constants/pageConstants/secretSanta";

const endpointConst = {
  appBannerData: GET_APP_BANNER_DATA_URL(),
  ctDisabledEvents: GET_CT_DISABLED_EVENT_LIST_URL(),
  geojs: "geojs",
  nudgeCityList: NUDGE_CITY_LIST,
  getIntDeliveryForRakhi: "getIntDeliveryForRakhi",
  dynamicSearchPlaceholder: "dynamicSearchPlaceholder",
  lottieIcons: LOTTIE_ICONS,
  saleNudge: SALE_NUDGE,
  trendingProducts: santaTrendingProducts,
  currencyList: CURRENCY_LIST,
  showFreeDeliveryTagForPdp: "showFreeDeliveryTagForPdp",
  accuracyWeightage: GET_ACCURACY_WEIGHTAGE_URL(),
};

const cacheKeyConst = {
  [endpointConst.appBannerData]: "appBannerData",
  [endpointConst.ctDisabledEvents]: "ctDisabledEvents",
  [endpointConst.geojs]: "geojs",
  [endpointConst.nudgeCityList]: NUDGE_CITY_LIST,
  [endpointConst.getIntDeliveryForRakhi]: "getIntDeliveryForRakhi",
  [endpointConst.dynamicSearchPlaceholder]: "dynamicSearchPlaceholder",
  [endpointConst.lottieIcons]: LOTTIE_ICONS,
  [endpointConst.saleNudge]: SALE_NUDGE,
  [endpointConst.trendingProducts]: santaTrendingProducts,
  [endpointConst.currencyList]: "currencyList",
  [endpointConst.showFreeDeliveryTagForPdp]: "showFreeDeliveryTagForPdp",
  [endpointConst.accuracyWeightage]: "accuracyWeightage",
};

export { endpointConst, cacheKeyConst };
